module.exports = __webpack_public_path__ + "img/mobile-device-image.589f879.png";